import styled from "styled-components";

export const IndexContainer = styled.div`
  > * {
    margin-bottom: 100px;
  }
`;
